import { sizes } from "../utils";
import type { MontaSVGProps } from "../types";
const RemoveRound = ({
  size = "medium",
  color = "inherit",
  ...props
}: MontaSVGProps) => {
  const computedSize = sizes[size] || size;
  props.style = {
    ...props.style,
    color
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      width={computedSize}
      height={computedSize}
      fill={color}
      {...props}
    >
      <g
        fill="none"
        stroke="#FF6A00"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M10.001 18.335a8.332 8.332 0 1 0 .001-16.665 8.332 8.332 0 0 0 0 16.665M7.5 12.5l5-5M7.5 7.5l5 5" />
      </g>
    </svg>
  );
};
export default RemoveRound;
